import React from 'react';
import * as ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const clientId = process.env.REACT_APP_CLIENT_ID;

// Baked in at build time. When it is missing the provider still mounts and
// every sign-in attempt fails with nothing in the console explaining why, so
// say so loudly -- a build that shipped without this variable is otherwise
// indistinguishable from a misconfigured OAuth client.
if (!clientId) {
  console.error(
    'REACT_APP_CLIENT_ID is not set. Sign-in cannot work. Rebuild the frontend ' +
    'with the Google OAuth web client ID for this deployment.'
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={clientId}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
